/* Napuplant — el selector de tallas de la vista rápida.

   EL PROBLEMA, que no era estético
   En la ventana emergente del upsell se elegía otra talla y el botón elegido
   no se marcaba: seguía en negro el primero. Eso era el síntoma visible. Lo
   grave estaba debajo: el formulario de la vista rápida manda la variante en
   un input oculto (snippets/product-info.liquid), sembrado por Liquid con
   `product.selected_or_first_available_variant`. Quien tiene que actualizarlo
   al cambiar de opción es el elemento <variant-radios> de Paris — y en la
   vista rápida no llega a hacerlo. Que la clase «active» no se moviera era la
   prueba: si ese manejador corriera, movería las dos cosas.

   Consecuencia real: el cliente pedía la talla grande y se le añadía la
   pequeña. Es el mismo tipo de fallo que llevó a apagar el botón de pago
   dinámico aquí (ver CLAUDE.md, «Vista rápida»): una ventana abierta desde el
   carrito que hace algo distinto de lo que el cliente ve.

   POR QUÉ NO SE ARREGLA EN theme.js
   Mismo criterio que con base.css y los botones: no se tocan los archivos de
   Paris. Esto se queda al margen, escucha en fase de burbuja y solo actúa
   dentro de #product-quic-kview, así que no puede afectar a la ficha de
   producto —que tiene su propio selector en napu-product.liquid y funciona— ni
   a ninguna otra parte del tema.

   Si algún día Paris empieza a funcionar aquí, los dos escribirían lo mismo:
   el mismo id en el mismo input y la misma clase en el mismo sitio. No hay
   conflicto posible, solo trabajo repetido.

   EL LISTENER ES DELEGADO EN document a propósito: la vista rápida se inyecta
   con innerHTML cada vez que se abre, así que cualquier listener puesto sobre
   sus elementos moriría al siguiente producto. */
(function () {
  'use strict';

  var CAJA = '#product-quic-kview';

  function leerVariantes(caja) {
    var el = caja.querySelector('[data-napu-qv-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Los valores elegidos, en el orden en que Shopify guarda las opciones.
     Se agrupa por el atributo name de los radios —que es el nombre de la
     opción, «Tamaño» o «Color»— y no por fieldset, para no depender de una
     etiqueta concreta del marcado de Paris. */
  function valoresElegidos(caja) {
    var vistos = [];
    var valores = [];
    caja.querySelectorAll('.swatch-option').forEach(function (input) {
      var n = input.getAttribute('name');
      if (!n || vistos.indexOf(n) !== -1) return;
      vistos.push(n);
      var marcado = caja.querySelector('.swatch-option[name="' + n + '"]:checked');
      valores.push(marcado ? marcado.value : null);
    });
    return valores;
  }

  function buscarVariante(variantes, valores) {
    for (var i = 0; i < variantes.length; i++) {
      var v = variantes[i], ok = true;
      for (var j = 0; j < valores.length; j++) {
        if (v.opciones[j] !== valores[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Lleva la galería de la vista rápida a la foto de la variante.

     La galería es de Paris (snippets/featured-product-media-gallery): un
     carrusel Flickity con una celda por foto, cada una con el id
     «product-media-<id de la foto>». Se busca en qué posición está esa celda y
     se le pide al carrusel que vaya ahí, igual que hace theme.js con
     .flickity('select', índice). Si no se puede hablar con Flickity, se pulsa
     la miniatura de esa misma posición: las miniaturas son otro carrusel con
     asNavFor sobre el principal, así que pulsarlas ya lo mueve.

     Todo se busca DENTRO de la caja de la vista rápida: si el cliente está en
     la ficha de esa misma maceta, la página tiene otra galería con los mismos
     id y no hay que tocarla. */
  function irAFoto(caja, mediaId) {
    var galeria = caja.querySelector('[data-featured-product-media]');
    var destino = caja.querySelector('#product-media-' + mediaId);
    if (!galeria || !destino) return;
    var celdas = galeria.querySelectorAll('.product-info-item');
    var indice = Array.prototype.indexOf.call(celdas, destino);
    if (indice < 0) return;

    try {
      var f = window.Flickity && window.Flickity.data ? window.Flickity.data(galeria) : null;
      if (f) { f.select(indice); return; }
      var $ = window.jQuery;
      if ($ && $.fn && $.fn.flickity && $(galeria).data('flickity')) {
        $(galeria).flickity('select', indice);
        return;
      }
    } catch (e) { /* se cae al plan B */ }

    var miniaturas = caja.querySelectorAll('.featured-product-thumb');
    if (miniaturas[indice]) miniaturas[indice].click();
  }

  function sincronizar(caja) {
    /* 1. El botón elegido. Se recorren todos y se marca el que contenga un
          radio marcado, en vez de quitar la clase al anterior y ponérsela al
          nuevo: así da igual de qué estado se venga. */
    caja.querySelectorAll('.product-swatch-item').forEach(function (item) {
      item.classList.toggle('active', !!item.querySelector('.swatch-option:checked'));
    });

    var variantes = leerVariantes(caja);
    if (!variantes || !variantes.length) return;

    var variante = buscarVariante(variantes, valoresElegidos(caja));

    /* 2. La variante que se va a añadir. Esto es lo que evita que el cliente
          se lleve una talla distinta de la que ha pedido. */
    var oculto = caja.querySelector('input[type="hidden"][name="id"]');
    if (oculto && variante) oculto.value = variante.id;

    /* 3. El precio. Llega ya formateado desde Liquid.
          Se cambia SOLO el importe ([data-product-actual-price]), no la caja
          entera [data-main-price]. Antes se hacía textContent sobre la caja y
          eso borraba el <span> con la letra grande y la línea «Impuesto
          incluido»: el precio se veía pequeño unos segundos, hasta que Paris
          lo repintaba entero (lo vio Alessandro el 24-sep-2026). */
    var cajaPrecio = caja.querySelector('[data-main-price]');
    if (cajaPrecio && variante && variante.precio) {
      var importe = cajaPrecio.querySelector('[data-product-actual-price]');
      if (importe) importe.textContent = variante.precio;
      var tachado = cajaPrecio.querySelector('[data-compare-price]');
      if (tachado) {
        if (variante.antes) { tachado.textContent = variante.antes; tachado.style.display = ''; }
        else { tachado.style.display = 'none'; }
      }
    }

    /* 3b. La foto de la variante. Al elegir un color, la galería va a la foto
          de ese color (Alessandro, 24-sep-2026). Si la variante no tiene foto
          propia no se mueve nada: mejor quedarse en la que está que saltar a
          una cualquiera. */
    if (variante && variante.media) irAFoto(caja, variante.media);

    /* 4. El botón de añadir. Una combinación inexistente o agotada no se puede
          comprar, y dejar el botón activo solo sirve para que el error salte
          más tarde y peor. */
    caja.querySelectorAll('[type="submit"], .product-form__submit, .add-to-cart').forEach(function (b) {
      b.disabled = !(variante && variante.disponible);
    });
  }

  document.addEventListener('change', function (e) {
    var destino = e.target;
    if (!destino || !destino.closest) return;
    if (!destino.classList || !destino.classList.contains('swatch-option')) return;
    var caja = destino.closest(CAJA);
    if (!caja) return;
    sincronizar(caja);
  });

  /* LA TALLA QUE LE CABE A LA PLANTA (24-sep-2026)

     En el cajón, cada maceta del upsell lleva data-napu-talla con el rango que
     le cabe a la planta del carrito (lo calcula snippets/napu-maceta-talla).
     Pasarlo por la URL no sirve: quick-view.js se queda solo con lo de antes
     del «?». Así que se apunta al pulsar «Añadir» y se marca cuando la ventana
     trae el contenido nuevo.

     LA TRAMPA: la ventana se reutiliza. Al pulsar, todavía tiene dentro la
     maceta anterior hasta que llega la nueva, y si se marcara la talla en
     cuanto hay radios, se marcaría en el contenido viejo y la nueva llegaría
     sin nada. Por eso solo se actúa cuando ENTRAN nodos con los radios de
     talla (addedNodes), que es lo que hace el innerHTML de quick-view.js; los
     cambios del icono de carga son de atributos y no cuentan.

     Si la talla no aparece entre los radios (se agotó entre medias), no se
     marca nada y queda lo que Paris traiga: el botón de añadir ya se apaga
     solo si la combinación no existe. */
  var pendiente = null;
  var observador = null;
  var reloj = null;

  /* El temporizador se guarda para cancelarlo: si no, el de un primer clic
     apagaría la escucha de un segundo clic hecho a los pocos segundos. */
  function parar() {
    if (observador) { observador.disconnect(); observador = null; }
    if (reloj) { clearTimeout(reloj); reloj = null; }
    pendiente = null;
  }

  function traeTallas(nodo) {
    if (!nodo || nodo.nodeType !== 1) return false;
    if (nodo.matches && nodo.matches('.swatch-option[name="Tamaño"]')) return true;
    return !!(nodo.querySelector && nodo.querySelector('.swatch-option[name="Tamaño"]'));
  }

  function marcar() {
    var caja = document.querySelector(CAJA);
    if (!caja || !pendiente) return;
    var radios = caja.querySelectorAll('.swatch-option[name="Tamaño"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === pendiente) {
        radios[i].checked = true;
        sincronizar(caja);
        break;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var boton = e.target && e.target.closest && e.target.closest('[data-quickview-action]');
    if (!boton) return;
    var tarjeta = boton.closest('[data-napu-talla]');
    if (!tarjeta) return;

    parar();
    pendiente = tarjeta.getAttribute('data-napu-talla');
    observador = new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var nuevos = cambios[i].addedNodes;
        for (var j = 0; j < nuevos.length; j++) {
          if (traeTallas(nuevos[j])) { marcar(); parar(); return; }
        }
      }
    });
    observador.observe(document.body, { childList: true, subtree: true });
    /* Si la ventana no llega a abrirse, no se deja nada escuchando. */
    reloj = setTimeout(parar, 10000);
  }, true);
})();
